export default [
  {
    meta: {
      icon: "iconfont iconjichuxinxiguanli",
      title: "挪车码",
      uri: "/newRetail/moveCar",
    },
    subMenus: [
      {
        meta: {
          icon: "iconfont iconxiaoshoushujuguanli",
          title: "挪车码生成",
          uri: "/newRetail/moveCar/edit",
        },
        component: () => import("./index.vue"),
        path: "/newRetail/moveCar/edit",
      },
    ],
  },
];
